var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-promo bg-white rounded-lg shadow-sm p-6 mb-10"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('h1', {
    staticClass: "text-xl font-bold text-neutral-700"
  }, [_vm._v(_vm._s(_vm.isEdit ? 'Edit Promo' : 'Buat Promo Baru'))])]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-6"
  }, [_c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Nama Promo")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Masukkan nama promo"
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Layanan Pengiriman")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.deliveryServices,
      "default": _vm.selectedDeliveryService,
      "optionLabel": "name",
      "placeholder": "Pilih layanan pengiriman"
    },
    on: {
      "input": function (val) {
        return _vm.selectedDeliveryService = val;
      },
      "change": _vm.onDeliveryServiceChange
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Service / Paket")]), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "multiple": "",
      "options": _vm.packageList,
      "label": "name",
      "placeholder": "Pilih service/paket"
    },
    model: {
      value: _vm.selectedPackages,
      callback: function ($$v) {
        _vm.selectedPackages = $$v;
      },
      expression: "selectedPackages"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Periode Promo")]), _c('date-range-picker', {
    staticClass: "w-full clean-daterange-picker",
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy HH:MM',
        separator: ' - '
      },
      "timePicker": true,
      "timePicker24Hour": true,
      "showDropdowns": true,
      "ranges": false
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function (picker) {
        return [_c('div', {
          staticClass: "w-full flex justify-between items-center rounded-lg border border-neutral-300 px-3 py-3"
        }, [_c('span', {
          staticClass: "text-sm text-neutral-700"
        }, [_vm._v(_vm._s(_vm._f("date")(picker.startDate)) + " - " + _vm._s(_vm._f("date")(picker.endDate)))]), _c('Calendar')], 1)];
      }
    }]),
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Persentase Diskon (%)")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 10"
    },
    model: {
      value: _vm.form.discount_percentage,
      callback: function ($$v) {
        _vm.$set(_vm.form, "discount_percentage", $$v);
      },
      expression: "form.discount_percentage"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Maksimal Nominal Diskon")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 3000"
    },
    model: {
      value: _vm.form.max_discount_amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "max_discount_amount", $$v);
      },
      expression: "form.max_discount_amount"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Kuota")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 50"
    },
    model: {
      value: _vm.form.quota,
      callback: function ($$v) {
        _vm.$set(_vm.form, "quota", $$v);
      },
      expression: "form.quota"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Kuota Tersedia")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 50",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.available_quota,
      callback: function ($$v) {
        _vm.$set(_vm.form, "available_quota", $$v);
      },
      expression: "form.available_quota"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "flex items-center gap-3"
  }, [_c('Toggle', {
    attrs: {
      "id": "status-toggle"
    },
    model: {
      value: _vm.statusActive,
      callback: function ($$v) {
        _vm.statusActive = $$v;
      },
      expression: "statusActive"
    }
  }), _c('span', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.statusActive ? 'Active' : 'Inactive'))])], 1)])]), _c('div', {
    staticClass: "mt-8 flex justify-end gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/promo');
      }
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? 'Menyimpan...' : _vm.isEdit ? 'Simpan Perubahan' : 'Simpan Promo') + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }